import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-welcome-layout',
  templateUrl: './welcome-layout.component.html',
  styleUrls: ['./welcome-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeLayoutComponent {}
